if (!customElements.get("product-showcase")) {
  customElements.define(
    "product-showcase",
    class ProductShowcase extends HTMLElement {


      constructor() {
        super();

        this.availables = this.dataset.avails.split(";").map(Number);
        this.prices = this.dataset.prices.split(";");
        this.origPrices = this.dataset.origPrices.split(";");

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        const variantsBtn = this.querySelectorAll(".ps1-var-btn");
        variantsBtn.forEach(button => {
          button.addEventListener('click', (e) => {
            this.onChangeVariant(e.currentTarget);
          })
        })
      }

      onChangeVariant(btn) {

        const selIndex = btn.dataset.varidx * 1;

        const variantsBtn = this.querySelectorAll(".ps1-var-btn");
        variantsBtn.forEach(button => {
          button.ariaSelected = button === btn;
        })

        const imgHolders = this.querySelectorAll(".ps1-c-p-img");
        imgHolders.forEach(imgHolder => {
          const selected = selIndex === (imgHolder.dataset.varidx * 1);
          imgHolder.ariaSelected = selected;
          if (selected) {
            const x = imgHolder.querySelector(".ps1-c-p-var-id");
            x.checked = true;
          }
        })

        const addBtn = this.querySelector(".ps1-quick-add");
        if (this.availables[selIndex] === 0 ) {
          addBtn.classList.add("hidden");
        } else {
          addBtn.classList.remove("hidden");
          this.querySelector(".ps1-quick-add-t").textContent = "Quick add — " + this.prices[selIndex];
        }

        this.querySelector(".ps1-pt-price-final").textContent = this.prices[selIndex];
        this.querySelector(".ps1-pt-price-compare").textContent = (this.prices[selIndex] === this.origPrices[selIndex]) ? "" : this.origPrices[selIndex];

      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        // this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".loading-spinner2").classList.remove(
          "hidden"
        );
        this.querySelector(".plus").classList.add(
            "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];


        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cartNotification
            .getSectionsToRender()
            .map((section) => section.section)
        );

        formData.append("sections_url", window.location.pathname);

        const data = Object.fromEntries(formData.entries());

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.log("ERRORERROR#" + response.status + "#" + response.description);
              this.handleErrorMessage(response.description);
              return;
            }

            this.cartNotification.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-spinner2").classList.add(
              "hidden"
            );
            this.querySelector(".plus").classList.remove(
                "hidden"
            );
          });


      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
